import { apiInitialState } from '../../../utils/reduxOperations';

export default{
    keyword:null,
    topicsApi: apiInitialState(),
    keywordApi: apiInitialState(),
    topicsRelationApi:apiInitialState()
};